import React from 'react';
import { useAngularService } from 'helpers/get_angular_service';
import currencyFormatter from '../../helpers/currency_formatter';

interface AutopaymentsGocardlessFormProps {
  applicationFee: number;
}

const AutopaymentsGocardlessForm = ({ applicationFee }: AutopaymentsGocardlessFormProps) => {
  const $rootScope = useAngularService('$rootScope');
  const gym = $rootScope.gym;

  return (
    <div className="payment-provider">
      <div className="payment-provider-logo">
        <img height="60px" src="/gocardless.svg" width="152px" />
      </div>
      <p className="stripe-note-fee" ng-if="applicationFee > 0">
        <strong>Please Note:</strong>An additional application fee of{' '}
        <strong>{currencyFormatter(applicationFee, gym.currency_symbol)} per transaction</strong>{' '}
        will be applied to all GoCardless payments processed through your Clubworx account.
      </p>
      <a
        className="btn btn-success"
        data-method="post"
        href={`/gyms/${gym.id}/gocardless/auths/auth_redirect`}
        rel="nofollow"
      >
        Connect GoCardless Account
      </a>
    </div>
  );
};

export default AutopaymentsGocardlessForm;
